// @flow
import React from 'react';
import type { Node } from 'react';
import TextField from '@material-ui/core/TextField';

type Props = $ReadOnly<{
    label: Node,
    labelNote?: Node,
    value?: string | number,
    children?: Node
}>;

function Field({ label, labelNote, value, children, ...rest }: Props) {
    return (
        <React.Fragment>
            <TextField
                label={label}
                helperText={labelNote}
                value={value || ''}
                margin="dense"
                variant="filled"
                fullWidth
                {...rest}
            />
            {children ? <div>
                {children}
            </div> : null}
        </React.Fragment>
    )
}

export default Field;